import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ConfigurationsService } from './shared/configurations.service';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.scss']
})
export class ConfigurationsComponent implements OnInit {
  public types = [];
  public isLoading = false;

  constructor(private configurationsService: ConfigurationsService, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getTypes();
  }
  getTypes() {
    this.isLoading = true;
    this.configurationsService.getAllTypes().subscribe(types => {
      this.isLoading = false;
      this.types = types;
    });
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations.component.ts